// extracted by mini-css-extract-plugin
export default {"campaignFilters":"CampaignFilters_campaignFilters__LCiLm","rightSide":"CampaignFilters_rightSide__zwHBM","newCampaignButton":"CampaignFilters_newCampaignButton__B+LwV"};